// Ported from packages/desk/src/mobile/AppSheet.tsx (docs/PLAN-2026-09-21-mobile-os-shell.md, step 4). Same file name and props
// as the desk copy, the dk- prefix renamed rdr-, so a fix in one is a copy in the other. Radar never imports @gamo/desk.
/**
 * An opened app on the phone: full screen, a title bar with Back to home and the app's name, the app's own content
 * under it. One app at a time, as before; the dock stays under it.
 */
import { Suspense, useEffect, useRef } from "react";
import type { RadarAppDefinition } from "../../apps/registry";
import type { WindowState } from "../store";
import { BackGlyph } from "./glyphs";

export function AppSheet({ def, win, onHome }: { def: RadarAppDefinition; win: WindowState; onHome: () => void }) {
  const title = useRef<HTMLHeadingElement>(null);
  // A new app starts with its name in focus, so a screen reader says where it is and Tab starts at the top.
  useEffect(() => {
    title.current?.focus({ preventScroll: true });
  }, [win.appId]);
  return (
    <section className="rdr-sheet rdr-mapp" data-rdr-window={win.appId} aria-labelledby={`rdr-mapp-${win.id}`}>
      <div className="rdr-sheet-top">
        <button type="button" className="back" onClick={onHome} aria-label="Back to home" data-rdr-back-home="">
          <BackGlyph />
          <span aria-hidden="true">Home</span>
        </button>
        <h1 ref={title} tabIndex={-1} id={`rdr-mapp-${win.id}`} className="title">
          {def.name}
        </h1>
      </div>
      <div className="rdr-sheet-body">
        <Suspense
          fallback={
            <div className="rdr-loading">
              <span>Loading…</span>
            </div>
          }
        >
          <def.Component windowId={win.id} launchParams={win.launchParams} />
        </Suspense>
      </div>
    </section>
  );
}
